import { t } from "ttag";

import {
  getMedicationRequestStatusLabel,
  MEDICATION_REQUEST_STATUS_COLOR,
} from "@/features/my-meds/models";
import type { PastMedicationRequest } from "@/features/my-meds/models";
import { Badge, EmptyState, IconWrapper, TableCard } from "@/shared/ui";
import { ResolutionIcon } from "./resolution-icon";

interface PastMedicationRequestsCardsProps {
  pastMedicationRequests: PastMedicationRequest[];
}

export const PastMedicationRequestsCards = ({
  pastMedicationRequests,
}: PastMedicationRequestsCardsProps) => {
  if (!pastMedicationRequests.length) {
    return (
      <EmptyState.Root className="md:hidden">
        <EmptyState.Icon />
        <EmptyState.Description>
          {t`No past medication requests yet`}
        </EmptyState.Description>
      </EmptyState.Root>
    );
  }
  return (
    <TableCard.Root>
      {pastMedicationRequests.map(
        ({
          dose,
          dateOfRequest,
          status,
          trackingNumber,
          resolution,
          supply,
          product,
          drugName,
        }) => (
          <TableCard.Row key={`past-medication-request-${trackingNumber}`}>
            <TableCard.Cell className="justify-between">
              <TableCard.Label>{t`Date`}</TableCard.Label>
              <TableCard.Data>{dateOfRequest}</TableCard.Data>
            </TableCard.Cell>

            {trackingNumber && (
              <TableCard.Cell>
                <TableCard.Label>{t`Tracking`}</TableCard.Label>
                <TableCard.Data>{trackingNumber}</TableCard.Data>
              </TableCard.Cell>
            )}

            <TableCard.Cell>
              <TableCard.Label>{t`Drug`}</TableCard.Label>
              <TableCard.Data>
                {product?.name ?? drugName ?? "-"}
              </TableCard.Data>
            </TableCard.Cell>
            <TableCard.Cell>
              <TableCard.Label>{t`Dose`}</TableCard.Label>
              <TableCard.Data>{dose ?? "-"}</TableCard.Data>
            </TableCard.Cell>
            <TableCard.Cell>
              <TableCard.Label>{t`Supply`}</TableCard.Label>
              <TableCard.Data>{supply ?? "-"}</TableCard.Data>
            </TableCard.Cell>

            <TableCard.Cell>
              <Badge
                color={MEDICATION_REQUEST_STATUS_COLOR[status]}
                size="x-small"
                className="min-w-24"
              >
                {getMedicationRequestStatusLabel(status)}
              </Badge>

              {resolution ? (
                <div className="inline-flex justify-center gap-1 text-sm leading-4 text-red-700">
                  <IconWrapper size="sm">
                    <ResolutionIcon resolution={resolution} />
                  </IconWrapper>
                  {resolution}
                </div>
              ) : (
                <TableCard.Data>-</TableCard.Data>
              )}
            </TableCard.Cell>
          </TableCard.Row>
        ),
      )}
    </TableCard.Root>
  );
};
